import { render, staticRenderFns } from "./roleInformation.vue?vue&type=template&id=77d5c706&scoped=true&"
import script from "./roleInformation.vue?vue&type=script&lang=js&"
export * from "./roleInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d5c706",
  null
  
)

export default component.exports